import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from '../abstractRequest';
import {FormBuilderEnums, MANUAL_DESCRIPTION,PERSONAL_DELIVERY} from '../../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../../nddUtils/configurationUtil.service';

@Injectable()
export class AlmaRequestAnyItem extends AbstractRequest{


    constructor(
        private mappingTablesCache: MappingTablesCache,
        private configurationUtil:ConfigurationUtil) {
        super();
        this.formFields = [
            {
                key: 'hold-or-booking',
                name: 'requestType',
                label: 'almaRequest.requestType',
                value: 'hold',
                path: 'groups-list-map/requestType',
                fieldType: FormBuilderEnums.FIELD_TYPE.INTERNAL,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,

                populator:  {
                    params:     {
                        defaultValue: FormBuilderEnums.FIRST
                    }
                },
                options:[
                    {
                        label:'almaRequest.requestType.hold',
                        value:'hold'
                    }
                ],
                events: {
                    onClick: this.onClick.bind(this),
                    params: []
                }

            },{
                key: MANUAL_DESCRIPTION,
                name: MANUAL_DESCRIPTION,
                label: 'almaRequestAnyItem.manualDescription',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },{
                key: 'pickupInstitution',
                name: 'pickupInstitution',
                path: 'groups-list-map/pickupInstitution',
                label: 'almaRequest.pickupInstitution',
                filterSearchPlaceHolderLabel: 'nui.request.lookUpInstitution',
                filterSearchAriaLabel: 'nui.aria.lookUpInstitution',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        byCategory: 'category',
                        filters :['pickupLocation','requestType']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },{
                key: 'pickupLocation',
                name: 'pickupLocation',
                path: 'groups-list-map/pickupLocation',
                label: 'almaRequest.pickupLocation',
                filterSearchPlaceHolderLabel: 'nui.request.lookUpLocation',
                filterSearchAriaLabel: 'nui.aria.lookUpLocation',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'key',
                        value:'value',
                        byCategory: 'category',
                        filters :['pickupInstitution' ,'requestType']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },
            {
                key: 'addressLine1',
                name: 'addressLine1',
                label: 'almaRequest.addressLine1',
                valuePath: 'chapterArticleTitle',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'addressLine2',
                name: 'addressLine2',
                label: 'almaRequest.addressLine2',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'addressLine3',
                name: 'addressLine3',
                label: 'almaRequest.addressLine3',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'addressLine4',
                name: 'addressLine4',
                label: 'almaRequest.addressLine4',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'city',
                name: 'city',
                label: 'almaRequest.city',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'stateProvince',
                name: 'stateProvince',
                label: 'almaRequest.stateProvince',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'postalCode',
                name: 'postalCode',
                label: 'almaRequest.postalCode',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'notNeedAfter',
                name: 'lastInterestDate',
                label: 'almaRequest.notNeedAfter',
                existingPath: 'hasHold',
                fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
                uiType: FormBuilderEnums.UI_TYPE.DATE,
                minDate: 'now',
                dependOn: {key : 'requestType', value: 'hold'},
                populator:  {
                    params:     {
                        allow       : FormBuilderEnums.FUTURE_DATES
                    }
                }
            },
            {
                key: 'comment',
                name: 'comment',
                label: 'almaRequest.comment',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'chapterArticleTitle',
                name: 'chapterArticleTitle',
                label: 'almaRequest.chapterArticleTitle',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'chapterArticleTitle',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'chapterArticleAuthor',
                name: 'chapterArticleAuthor',
                label: 'almaRequest.chapterArticleAuthor',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'chapterArticleAuthor',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'startPage',
                name: 'startPage',
                label: 'almaRequest.startPage',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'startPage',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'endPage',
                name: 'endPage',
                label: 'almaRequest.endPage',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'endPage',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'volume',
                name: 'volume',
                label: 'almaRequest.volume',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'volume',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'issue',
                name: 'issue',
                label: 'almaRequest.issue',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'issue',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'part',
                name: 'part',
                label: 'almaRequest.part',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'part',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'publicationDate',
                name: 'publicationDate',
                label: 'almaRequest.publicationDate',
                saveFormField:null,
                tooltip:'',
                mandatoryGroup:MANUAL_DESCRIPTION,
                value: '',
                valuePath: 'publicationDate',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'genericCheckBox',
                name: 'genericCheckBox',
                label: '',
                value: '',
                existingPath: 'dummyPath',
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                populator:  {
                    deleteFromFormDataIfHidden: 'true'
                },
                options:[
                    {
                        label: 'almaRequest.genericCheckBox',
                        value:'N'
                    }
                ]
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/alma/AlmaRequestAnyItem.ts